import assign = require('object-assign');
import { FETCH_CUSTOMERS_REQUEST, FETCH_CUSTOMERS_SUCCESS, FETCH_CUSTOMERS_FAILURE } from '../constants/Customer';

import { ITagState } from '../interfaces/states';

const initialState: ITagState = {
    byId: {},
    arr: []
};

export default function states(state = initialState, action): ITagState {
    switch (action.type) {
        case FETCH_CUSTOMERS_REQUEST: {
            return assign({}, state, {
                loading: true
            });
        }
        case FETCH_CUSTOMERS_SUCCESS: {
            const byId = assign({}, state.byId);
            const arr = [
                ...state.arr
            ];

            const customers = action.payload;

            customers.forEach(customer => {
                byId[customer.cId] = customer;
                arr.push(customer.cId);
            });

            return assign({}, state, {
                loading: false,
                byId,
                arr
            });
        }
        case FETCH_CUSTOMERS_FAILURE: {
            return assign({}, state, {
                loading: false,
                error: action.error
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/customers.ts